import { get, post } from '../http-calls';

export const getServDashScreenByCode = async (screenCode) => {
    let res = await get(`MADashboard/MADashboard_GetDashboardData?MADashboardID=${screenCode || ''}`, { useAuthToken: true });
    return res;
};
export const getServiceDashboardData = async (screenID, period, year, branchIDs = [], franchises = []) => {
    let IsGroup = branchIDs.filter((item) => item.id == '-99').length > 0 ? true : false;
    let branchID = IsGroup ? -99 : branchIDs.map((item) => item.id).join('&BranchID=');
    let franchise = franchises.map((item) => item.id).join('&FranchiseCode=');
    let res = await get(
        `MAdashboard/MADashboard_GetData?MADashboardID=${screenID}&Period=${period}&Year=${year}&BranchID=${branchID}&FranchiseCode=${franchise}`,
        {
            useAuthToken: true
        }
    );
    return res;
};
export const getAccountCodeData = async (catID, period, year, branchID, franchise) => {
    // let franchise = franchiseLIST.map((item) => item).join('&FranchiseCode=');
    let res = await get(
        `MADashboard/MAAccountBy_CategoryID?Period=${period}&Year=${year}${branchID ? `&BranchID=${branchID}` : ''}&CategoryID=${catID}&FranchiseCode=${
            franchise ? franchise : ''
        }`,
        {
            useAuthToken: true
        }
    );
    return res;
};
